import { map } from 'lodash'
import { type FC } from 'react'

import { Text, VStack, type VStackProps } from '@/components'

export type ProfileInfoPromptItem = {
  answer: string
  question: string
}

export interface ProfileInfoPromptsProps extends VStackProps {
  items: ProfileInfoPromptItem[]
}

export const ProfileInfoPrompts: FC<ProfileInfoPromptsProps> = ({ items, ...props }) => {
  if (!items.length) {
    return null
  }

  return (
    <VStack
      className='gap-2'
      {...props}
    >
      <Text
        className='font-poppinsSemiBold color-white'
        numberOfLines={1}
        size='lg'
      >
        Get to Know Me
      </Text>
      <VStack className='gap-3'>
        {map(items, (item, index) => (
          <VStack
            accessible
            accessibilityLabel={`${item.question}: ${item.answer}`}
            className='gap-1 rounded-xl bg-white/20 px-3 py-2'
            importantForAccessibility='yes'
            key={index}
            tabIndex={0}
          >
            <Text
              accessibilityElementsHidden
              aria-hidden
              className='font-poppinsSemiBold color-white'
              importantForAccessibility='no-hide-descendants'
            >
              {item.question}
            </Text>
            <Text
              accessibilityElementsHidden
              aria-hidden
              className='font-poppinsRegular text-white'
              importantForAccessibility='no-hide-descendants'
            >
              {item.answer}
            </Text>
          </VStack>
        ))}
      </VStack>
    </VStack>
  )
}
